import React from 'react';
import { Box, Paper, CircularProgress } from '@mui/material';

const ContentLayout = ({
  children,
  loading = false,
  error = null,
  padding = 3,
  noPaper = false,
}) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Paper
        sx={{
          p: 3,
          backgroundColor: 'error.light',
          color: 'error.contrastText',
        }}
      >
        {error}
      </Paper>
    );
  }

  if (noPaper) {
    return (
      <Box 
        sx={{ 
          p: padding,
          pt: { xs: 4, md: 5 },
          backgroundColor: 'rgb(255, 255, 255)',
          minHeight: '100vh',
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Paper
      sx={{
        p: padding,
        pt: { xs: 4, md: 5 },
        backgroundColor: 'background.paper',
        borderRadius: 2,
      }}
    >
      {children}
    </Paper>
  );
};

export default ContentLayout;
